import React from 'react';
import styles from './HeaderDoc.module.scss';
import moment from 'moment';

const HeaderDoc = ({ document, mode }) => {
  return (
    <div>
      <div className={styles.heading}>
        {mode === 'edit' ? 'Редактирование документа' : 'Новый документ'}
      </div>
      {mode === 'edit' && (
        <div className={styles.description}>
          Документ: Номер {document?.docNumber} от{' '}
          {moment(document?.createDate).format('DD.MM.YYYY')}
        </div>
      )}
    </div>
  );
};

export default HeaderDoc;
